import React, {useEffect} from "react";

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';


function CustomSnackBar(props) {
    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
        });
    
    const [snackbarOpen, setSnackbarOpen] = React.useState();
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        // props.setBucketValue( {...props.bucket, snackbar: {...props.bucket.snackbar, open: false}} );
        props.setBucketValue( {snackbar: {...props.bucket.snackbar, open: false}} );
        setSnackbarOpen(false);
    };

    // The following section is for testing...
    // useEffect(() => {
    //     console.log("-------- Use Effect......");
    //     if(props.bucket.sbArray && props.bucket.sbArray.length > 0) {
    //         console.log("> Reset the bucket......");
    //         console.log(">> SnackBar Array: " + JSON.stringify(props.bucket.sbArray));
    //         props.setBucketValue( {...props.bucket, sbArray: []} );
    //     }
    // });

    useEffect(() => {
        setSnackbarOpen(props.bucket.snackbar!=null ?  props.bucket.snackbar.open : false);
    });

    return(
        <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={props.bucket?.snackbar?.severity} sx={{ width: '100%' }}>
                {props.bucket?.snackbar?.message}
            </Alert>
        </Snackbar>
    );
}

export default CustomSnackBar;